export const UPDATE_CUSTOMER_REQUEST = 'UPDATE_CUSTOMER_REQUEST';
export const UPDATE_CUSTOMER_SUCCESS = 'UPDATE_CUSTOMER_SUCCESS';
export const UPDATE_CUSTOMER_FAILURE = 'UPDATE_CUSTOMER_FAILURE';


export const updateCustomerRequest = (updateCustomerDto) => ({
    type: UPDATE_CUSTOMER_REQUEST,
    payload: updateCustomerDto,
});

export const updateCustomerSuccess = (customer) => ({
    type: UPDATE_CUSTOMER_SUCCESS,
    payload: customer
});

export const updateCustomerFailure = (error) => ({
    type: UPDATE_CUSTOMER_FAILURE,
    payload: error,
});

